import { Routes } from '@angular/router';
import { LayoutComponent } from './@shared/components/layout/layout.component';
import { authGuard } from './@core/authentication';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./@features/auth/auth.routes').then(m => m.AuthRoutes)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./@features/main.routes').then((m) => m.MainRoutes),
  },
];
